import { RefObject, useEffect, useRef, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import ls from 'localstorage-slim';
import Slider from 'react-slick';
import cn from 'classnames';

import { Hero } from './containers/Hero/Hero';
import { Menu } from './components/Menu/Menu';
import { EasyBuy } from './containers/EasyBuy/EasyBuy';
import { Advantages } from './containers/Advantages/Advantages';
import { LostTicket } from './containers/LostTicket/LostTicket';
import { MenuItems } from './types/MenuItems';
import { Together } from './containers/Together/Together';
import { Login } from './containers/Login/Login';
import { Register } from './containers/Register/Register';
import { Footer } from './containers/Footer/Footer';
import { SixInTix } from './containers/SixInTix/SixInTix';
import { Dashboard } from './containers/Dashboard/Dashboard';
import { Shop } from './containers/Shop/Shop';
import { Settings } from './containers/Settings/Settings';
import { Marketing } from './containers/Marketing/Marketing';
import { Statistics } from './containers/Statistics/Statistics';
import { Finance } from './containers/Finance/Finance';
import { Sections } from './types/Sections';
import { SixNavbar } from './components/SixNavbar/SixNavbar';
import { isSixInHash } from './helpers/isSixInHash';
import { MAIN_SECTIONS_LIST } from './constants/sections';
import { SliderComponent } from './components/SliderComponent/SliderComponent';

import './styles/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import { TogetherSale } from './containers/TogetherSale/TogetherSale';
import { getDefinedRegion } from './helpers/getRegion';

function App() {
  const [hash, setHash] = useState('');
  const [isLoaded, setLoaded] = useState(false);
  const [isSixPagesLoad, setSixPagesLoad] = useState(false);
  const [isMenuPagesLoad, setMenuPagesLoad] = useState(false);
  const [isScroll, setScroll] = useState(false);

  const sliderRef = useRef() as RefObject<Slider>;
  const html = document.getElementById('html');
  const domen = getDefinedRegion();

  if (html) {
    html.dataset.theme = domen;
  }

  useEffect(() => {
    window.addEventListener('hashchange', () => {
      setHash(window.location.hash);
    });
    setLoaded(true);

    if (window.location.pathname !== '/' + MenuItems.TOGETHER_SALE) {
      window.location.hash = Sections.EASYBUY;
    }

    ls.clear();
    ls.set('isMenuOpen', false);

    window.setTimeout(() => {
      setScroll(true);
      setSixPagesLoad(true);
      setMenuPagesLoad(true);
    }, 1500 * 3);

    const resizeOps = () => {
      document.documentElement.style.setProperty(
        '--vh',
        window.innerHeight * 0.01 + 'px',
      );
    };

    resizeOps();
    window.addEventListener('resize', resizeOps);

    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }, []);

  useEffect(() => {
    if (isLoaded) {
      let allowScroll = false;
      let startScrolY = window.pageYOffset;

      window.setTimeout(() => {
        allowScroll = true;
      }, 1500 * 3);

      const handleWheelEvent = (e: WheelEvent) => {
        const isMainPage =
          window.location.hash === `#${Sections.EASYBUY}` ||
          window.location.hash === `#${Sections.ADVANTAGES}` ||
          window.location.hash === `#${Sections.SIXINTIX}`;

        if (!isMainPage) return;

        if (!allowScroll) return;
        const currPageIndex = MAIN_SECTIONS_LIST.findIndex(
          (el) => '#' + el === window.location.hash,
        );

        if (e.deltaY > 0 && currPageIndex < MAIN_SECTIONS_LIST.length - 1) {
          const targetSectionId = MAIN_SECTIONS_LIST[currPageIndex + 1];
          window.location.hash = targetSectionId;

          const section = document.getElementById(
            targetSectionId,
          ) as HTMLElement;

          section.classList.add(`main__${targetSectionId}--shown`);

          window.removeEventListener('wheel', handleWheelEvent);

          allowScroll = false;

          window.setTimeout(() => {
            allowScroll = true;

            window.addEventListener('wheel', handleWheelEvent);
          }, 1200);
        }

        if (e.deltaY < 0 && currPageIndex !== 0) {
          const targetSectionId = MAIN_SECTIONS_LIST[currPageIndex];
          window.location.hash = MAIN_SECTIONS_LIST[currPageIndex - 1];

          const section = document.getElementById(
            targetSectionId,
          ) as HTMLElement;
          section.classList.remove(`main__${targetSectionId}--shown`);

          window.removeEventListener('wheel', handleWheelEvent);

          allowScroll = false;

          window.setTimeout(() => {
            allowScroll = true;

            window.addEventListener('wheel', handleWheelEvent);
          }, 1200);
        }
      };

      const handleTouchStart = () => {
        startScrolY = window.pageYOffset > 0 ? window.pageYOffset : 0;

        if (
          !window.location.hash.includes(Sections.EASYBUY) &&
          startScrolY === 0
        ) {
          const currPageIndex = MAIN_SECTIONS_LIST.findIndex(
            (el) => '#' + el === window.location.hash,
          );
          window.scrollTo(0, 200 * currPageIndex);
          startScrolY = 200 * currPageIndex;
        }
      };

      const handleTouchEnd = () => {
        const isMainPage =
          window.location.hash === `#${Sections.EASYBUY}` ||
          window.location.hash === `#${Sections.ADVANTAGES}` ||
          window.location.hash === `#${Sections.SIXINTIX}`;

        if (!isMainPage) return;

        if (!allowScroll) return;

        const currPageIndex = MAIN_SECTIONS_LIST.findIndex(
          (el) => '#' + el === window.location.hash,
        );

        if (
          window.pageYOffset > startScrolY &&
          currPageIndex < MAIN_SECTIONS_LIST.length - 1
        ) {
          const targetSectionId = MAIN_SECTIONS_LIST[currPageIndex + 1];
          window.location.hash = targetSectionId;

          const section = document.getElementById(
            targetSectionId,
          ) as HTMLElement;
          section.classList.add(`main__${targetSectionId}--shown`);
          allowScroll = false;

          window.removeEventListener('touchstart', handleTouchStart);
          window.removeEventListener('touchend', handleTouchEnd);

          window.setTimeout(() => {
            if (currPageIndex + 1 === 2) {
              window.scrollTo(0, 400);
            } else {
              window.scrollTo(0, 200 * (currPageIndex + 1));
            }
            allowScroll = true;
            window.addEventListener('touchstart', handleTouchStart);
            window.addEventListener('touchend', handleTouchEnd);
          }, 500);
        }

        if (window.pageYOffset < startScrolY && currPageIndex !== 0) {
          const targetSectionId = MAIN_SECTIONS_LIST[currPageIndex];
          window.location.hash = MAIN_SECTIONS_LIST[currPageIndex - 1];

          const section = document.getElementById(
            targetSectionId,
          ) as HTMLElement;
          section.classList.remove(`main__${targetSectionId}--shown`);

          allowScroll = false;

          window.removeEventListener('touchstart', handleTouchStart);
          window.removeEventListener('touchend', handleTouchEnd);

          window.setTimeout(() => {
            if (currPageIndex - 1 === 0) {
              window.scrollTo(0, 0);
            } else {
              window.scrollTo(0, 200 * (currPageIndex - 1));
            }

            allowScroll = true;
            window.addEventListener('touchstart', handleTouchStart);
            window.addEventListener('touchend', handleTouchEnd);
          }, 500);
        }
      };

      if ('ontouchstart' in document.documentElement) {
        window.addEventListener('touchstart', handleTouchStart);
        window.addEventListener('touchend', handleTouchEnd);
      } else {
        window.addEventListener('wheel', handleWheelEvent);
      }
    }
  }, [isLoaded]);

  useEffect(() => {
    if (hash.includes(MenuItems.LOGIN)) {
      setMenuPagesLoad(true);
    }
  }, [window.location.hash]);

  return (
    <div
      className="sixtix"
      id="sixtix"
      style={{
        height: `${isScroll ? 'calc(var(--vh, 1vh) * 100 + 400px)' : '100%'}`,
      }}
    >
      <ToastContainer
        position="top-right"
        transition={Slide}
        autoClose={3000}
        pauseOnHover={false}
        closeButton
        closeOnClick={false}
        theme="light"
        draggable
      />

      <Routes>
        <Route
          path={'/' + MenuItems.TOGETHER_SALE}
          element={<TogetherSale />}
        />
        <Route
          path="*"
          element={
            <>
              <Menu position="fixed" />

              <Menu
                position="fixed"
                customClassName={cn('menu--horizontal', {
                  'menu--horizontal-hidden':
                    isSixInHash() || hash.includes(Sections.SIXINTIX),
                })}
                sliderRef={sliderRef}
              />

              {window.screen.width >= 0 ? (
                <div
                  style={{
                    visibility: `${isMenuPagesLoad ? 'visible' : 'hidden'}`,
                  }}
                >
                  <LostTicket />
                  <Together />
                  <TogetherSale />
                  <Register />
                  <Login />
                </div>
              ) : (
                <SliderComponent sliderRef={sliderRef} />
              )}

              <Hero />
              <div
                style={{
                  visibility: `${isSixPagesLoad ? 'visible' : 'hidden'}`,
                }}
              >
                <Dashboard />
                <Shop />
                <Settings />
                <Marketing />
                <Statistics />
                <Finance />
              </div>
              <SixNavbar />
              <main className="sixtix__main main">
                <EasyBuy />

                <Advantages />

                <SixInTix />
              </main>
              <Footer sliderRef={sliderRef} />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
